import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import axios from "axios";
// eslint-disable-next-line no-unused-vars
import { Container, Row, Col, Spinner} from "react-bootstrap";
import { showToast } from '../../../components/common/notification/Notification';
import PostDetailCard from "./PostDetailCard";

import PropertyComment from "../property/PropertyComment";

const PostDetail = ({back, ownerId: setOwnerId}) => {
  const { Id } = useParams(); 
  const [postData, setPostData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [isError, setIsError] = useState(false);
  const loggedInUser = useSelector((state) => state.auth.user);
  const token = loggedInUser?.refreshToken; 
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const assetUrl = process.env.REACT_APP_ASSET_URL;

  const [mediaData, setMediaData] = useState({
    images: [],
    promotion_videos: [],
    attachments: [],
  });

  useEffect(() => {
    fetchPostItem();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Id]);

  const fetchPostItem = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(
        `${baseUrl}/property/lead/${Id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      ); 
      console.log(response.data.lead);

      if (response.status === 200) {
        const post = response.data.lead;
        const owner = post.user?.id || post.customer?.id;
        if (setOwnerId && owner) {
          setOwnerId(owner);
        }

        const rawFirstName = post.user?.first_name || post.customer?.first_name;
        const rawLastName = post.user?.last_name || post.customer?.last_name;
        let cleanName = [rawFirstName, rawLastName].filter(Boolean).join(" ");
        if (!cleanName || cleanName.toLowerCase().includes("null")) {
          cleanName =
            post.customer_name && !post.customer_name.toLowerCase().includes("null")
              ? post.customer_name
              : post.user?.name ||
                (post.user?.email_address ? post.user.email_address.split("@")[0] : null) ||
                (post.customer?.email_address ? post.customer.email_address.split("@")[0] : null) ||
                "User";
        }

        // Capitalize nicely
        if (cleanName && typeof cleanName === "string") {
          cleanName = cleanName.charAt(0).toUpperCase() + cleanName.slice(1);
        }

        setPostData({
          ownerId: owner,
          creatorName: cleanName,
          city: post.city_name,
          state: post.state_name,
          country: post.country_name,
          description: post.description,
          createdOn: post.created_on,
          images: post.images,
          videos: post.videos,
          attachments: post.attachments,
          photo: post.customer?.photo || post.user?.photo || post.photo,
          service: post.service,
        });

        // Update media
        setMediaData({
          images: (post.images || []).map((img) => ({
            url: img.image_url?.startsWith("http") ? img.image_url : assetUrl + img.image_url,
          })),
          videos: (post.videos || []).map((video) => ({
            url: video.url_path?.startsWith("http") ? video.url_path : assetUrl + video.url_path,
          })),
          attachments: (post.attachements || post.attachments || []).map((attachment) => ({
            url: attachment.attachment_url?.startsWith("http") ? attachment.attachment_url : assetUrl + attachment.attachment_url,
          })),
        });
      } else {
        showToast("Failed to fetch data", { type: "error" });
      }
    } catch (error) {
      setIsError(true);
      console.error("Fetch error:", error);
      showToast("Error fetching data", { type: "error" });
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <div className="text-center py-5">
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  if (!postData) {
    return null;
  }

  return (
    <>
      <PostDetailCard
        creatorName={postData.creatorName}
        description={postData.description}
        createdOn={postData.createdOn}
        state={postData.state}
        city={postData.city}
        images={mediaData.images}
        videos={mediaData.videos}
        attachments={mediaData.attachments}
        service={postData.service}
        photo={postData.photo}
        back={back}
      />
      <div style={{ maxWidth: "1050px", margin: "0 auto" }}>
        <PropertyComment
          Id={Id}
          ownerId={postData.ownerId}
          commentType="requestComments"
          allComments="/property/requestComments"
          addComment="/property/addRequestComment"
          editComment="/property/editRequestComment"
          deleteComment="/property/deleteRequestComment/"
        />
      </div>
    </>
  );
}
export default PostDetail;